import React, { useEffect } from 'react';
import { Modal } from './ui';
import { useUserStore } from '../store';
import { Region } from '../types';

interface RegionOption {
  code: Region;
  name: string;
  subtitle: string;
  image?: string;
  gradient: string;
}

const REGIONS: RegionOption[] = [
  {
    code: 'TR',
    name: 'Турция',
    subtitle: 'Самый популярный',
    image: '/regions/tr.webp',
    gradient: 'linear-gradient(135deg, #E30A17 0%, #8B0510 100%)',
  },
  {
    code: 'IN',
    name: 'Индия',
    subtitle: 'Новинки дешевле',
    image: '/regions/in.webp',
    gradient: 'linear-gradient(135deg, #FF9933 0%, #138808 100%)',
  },
  {
    code: 'UA',
    name: 'Украина (СНГ)',
    subtitle: 'Больше игр на русском',
    image: '/regions/ua.webp',
    gradient: 'linear-gradient(135deg, #5370F5 0%, #3657F0 100%)',
  },
];

interface RegionBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (region: Region) => void;
}

export const RegionBottomSheet: React.FC<RegionBottomSheetProps> = ({ isOpen, onClose, onSelect }) => {
  const setLastSelectedRegion = useUserStore((s) => s.setLastSelectedRegion);

  // Preload images
  useEffect(() => {
    if (!isOpen) return;
    REGIONS.forEach((r) => {
      if (!r.image) return;
      const img = new Image();
      img.src = r.image;
    });
  }, [isOpen]);

  const handleSelect = (region: Region) => {
    setLastSelectedRegion(region);
    onSelect?.(region);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Выберите регион PlayStation" noScroll>
      <div className="space-y-3 pb-2">
        {REGIONS.map((r) => {
          return (
            <button
              key={r.code}
              onClick={() => handleSelect(r.code)}
              className="w-full relative overflow-hidden rounded-2xl active:scale-[0.98] transition-all"
              style={{
                aspectRatio: '1200 / 380',
                background: r.gradient,
              }}
            >
              {r.image && (
                <img
                  src={r.image}
                  alt={r.name}
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ objectPosition: 'center' }}
                  decoding="async"
                />
              )}
              <div className="absolute inset-0 flex items-center pl-[46%] pr-4">
                <div className="flex-1 min-w-0 text-left">
                  <div
                    className="text-white text-[20px] font-bold text-left"
                    style={{ fontFamily: 'Manrope, sans-serif', lineHeight: '120%', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}
                  >
                    {r.name}
                  </div>
                  <div
                    className="text-white/95 text-[13px] mt-0.5 text-left"
                    style={{ textShadow: '0 1px 4px rgba(0,0,0,0.7)' }}
                  >
                    {r.subtitle}
                  </div>
                </div>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 ml-3"
                  style={{ filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.4))' }}
                >
                  <path d="M9 6l6 6-6 6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </button>
          );
        })}
      </div>
    </Modal>
  );
};
